import {
  EDITOR_THEME_CONTENT_TEXT_COLOR_COMMAND,
  EDITOR_THEME_CONTENT_TEXT_COLOR_FORMAT,
} from './useEditorThemeContent.constants'

export function isEditorThemeContentTextColorCommand({ command, ui }) {
  return (
    command === EDITOR_THEME_CONTENT_TEXT_COLOR_COMMAND &&
    ui === EDITOR_THEME_CONTENT_TEXT_COLOR_FORMAT
  )
}
